const TERMS_OF_USE_AND_SALE = 'https://legal.fabfitfun.com/#terms-of-use';
const FABFITFUN_MEMBERSHIP_TERMS = 'https://legal.fabfitfun.com/#box-membership-terms';
const FABFITFUN_SUBSCRIBABLE_TERMS = 'https://legal.fabfitfun.com/#refills-terms-conditions';

export {
  TERMS_OF_USE_AND_SALE,
  FABFITFUN_MEMBERSHIP_TERMS,
  FABFITFUN_SUBSCRIBABLE_TERMS,
};
